import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
let PitGridPage = class PitGridPage {
    constructor() {
        this._totalPagesCount = 0;
        /**
         * Поле дублирующее totalRowsCount в некоторых случаях
         */
        this.totalCount = 0;
    }
    getPageIndex() {
        return this._pageIndex;
    }
    setPageIndex(value) {
        this._pageIndex = value;
    }
    getPageSize() {
        return this._pageSize;
    }
    setPageSize(value) {
        this._pageSize = value;
    }
    getTotalRowsCount() {
        return this._totalRowsCount || this.totalCount;
    }
    getTotalPagesCount() {
        return this._totalPagesCount;
    }
    getPageData() {
        return this.pageData;
    }
    get pageIndex() {
        return this._pageIndex;
    }
    set pageIndex(value) {
        this._pageIndex = value;
    }
    get pageSize() {
        return this._pageSize;
    }
    set pageSize(value) {
        this._pageSize = value;
    }
    get totalRowsCount() {
        return this.totalCount || this._totalRowsCount;
    }
    set totalRowsCount(value) {
        this._totalRowsCount = value;
    }
    get totalPagesCount() {
        return this._totalPagesCount;
    }
    set totalPagesCount(value) {
        this._totalPagesCount = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "pageIndex", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitGridPage.prototype, "_pageIndex", void 0);
tslib_1.__decorate([
    jsonMember({ name: "pageSize", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitGridPage.prototype, "_pageSize", void 0);
tslib_1.__decorate([
    jsonMember({ name: "totalRowsCount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitGridPage.prototype, "_totalRowsCount", void 0);
tslib_1.__decorate([
    jsonMember({ name: "totalPagesCount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitGridPage.prototype, "_totalPagesCount", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitGridPage.prototype, "totalCount", void 0);
PitGridPage = tslib_1.__decorate([
    jsonObject
], PitGridPage);
export { PitGridPage };
